import { BaseAccessTokenService } from '@pflegia/ui/application/identity/services/base-access-token.service';

import { PostHogService } from '@shared/application/ab-testing/posthog.service';
import { segmentService } from '@shared/application/analytics/segment.service';

export const accessTokenService = new BaseAccessTokenService(segmentService, new PostHogService());
